import { uniqueId } from 'lodash';
import React from 'react';

import ContactForm from './ContactForm';
import { latamGlobalVariables } from './latamGlobalVariables';

const ContactFormWrapper: React.FunctionComponent<any> = ({
  textColor,
  siteTag,
}) => {
  const [state, setState] = React.useState({
    active: false,
    contactActive: false,
    firstName: '',
    lastName: '',
    phone: '',
    company: '',
    email: '',
    locations: '',
    restaurantNumbers: '',
    typeOfRestaurants: '',
    restaurantRoles: '',
  });

  const stateHandler = (newState: Partial<typeof state>) =>
    setState((prevState) => ({ ...prevState, ...newState }));

  const parentId = uniqueId('contact-form-parent-');
  const prefixId = uniqueId('contact-form-prefix-');
  const fields = latamGlobalVariables[siteTag];

  const backwardsCompatibleSiteTag = siteTag.split(':')[1];

  return (
    <div id={parentId}>
      <ContactForm
        parentId={`#${parentId}`}
        prefixId={prefixId}
        stateHandler={stateHandler}
        fields={fields}
        color={textColor}
        siteTag={backwardsCompatibleSiteTag}
        {...state}
      />
    </div>
  );
};

export default ContactFormWrapper;
